export const currentAccount = {
    currentAccountTicketingService: { enabled: true },
    freeCashWithdrawal: { enabled: true },
    secondaryIdManagement: {
        enabled: true,
    },
    requestToPay: { enabled: true },
    roundupSavings: { enabled: false },
    currentAccountOverdraftSetup: { enabled: false },
    currentAccountOverdraftChange: { enabled: false },
    moneyAside: { enabled: false },
    currentAccountArchive: { enabled: false },
    currentAccountInsurance: { enabled: true },
    currentAccount: { associatedCards: { enabled: true } },
};
